function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #26a9e0;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M356.46,95.36v17.13h17.75V95.36h13.21v47.1H374.21V123.81H356.46v18.65H343.25V95.36Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M409.57,95.36v25.58c0,7.41,2.73,12.16,8.74,12.16s8.73-4.4,8.73-12.16V95.36h13.21v25.23c0,15.37-8.18,22.71-22.5,22.71-13.49,0-21.39-6.84-21.39-23.06V95.36Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M449.19,96a116.65,116.65,0,0,1,16-1c7.41,0,11.25.49,14.95,2,4,1.54,7.2,5,7.2,10,0,4-2.24,7.76-8,9.79v.14c5.87,1.53,9.58,5.73,9.58,11.6A12.81,12.81,0,0,1,483.09,139c-3.78,2.52-9.93,4-20.41,4a90.31,90.31,0,0,1-13.49-.83Zm13.07,17.19h2.8c6.15,0,8.94-1.67,8.94-4.61,0-2.65-2.3-4.19-7-4.19a30.29,30.29,0,0,0-4.75.28Zm0,20.13a35,35,0,0,0,4.27.14c4.61,0,8.45-1.61,8.45-5.73s-4-5.31-9.29-5.31h-3.43Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M154.46,126l-5.82,16.47h-3.41l17-47.1h3.23l17,47.1H179L173.1,126Zm17.62-2.8-5.73-15.74c-1.15-3.26-1.78-5.62-2.46-8.29h-.17c-.67,2.74-1.42,5.18-2.45,8.15l-5.76,15.88Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M194,98.16H178.6v-2.8h34v2.8H197.28v44.3H194Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M220.85,95.36v47.1h-3.32V95.36Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M254.43,119.05H235.59v20.6h21.07v2.81H232.27V95.36h23.27v2.82H235.59v18.06h18.84Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M264.84,142.46V95.36H268l18.36,27.83A151.47,151.47,0,0,1,295.2,138l.14-.11c-.49-6.32-.54-11.7-.54-19.11V95.36H298v47.1h-3.11l-18-27.41a150.51,150.51,0,0,1-9.12-15.23l-.2.1c.39,5.8.44,10.87.44,18.71v23.83Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M318.35,98.16H303v-2.8h34v2.8H321.67v44.3h-3.32Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 76.74,
  cy: 67.64,
  r: 15.23
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M80.29,103.72A15.93,15.93,0,1,1,98.54,90.49,16,16,0,0,1,80.29,103.72Zm4.8-30.08a14.52,14.52,0,1,0,12,16.63A14.53,14.53,0,0,0,85.09,73.64Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 20.19,
  cy: 62.25,
  r: 19.48
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M23.07,102.53A20.19,20.19,0,1,1,46.19,85.77,20.2,20.2,0,0,1,23.07,102.53Zm6.14-38.47A18.77,18.77,0,1,0,44.79,85.55,18.78,18.78,0,0,0,29.21,64.06Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 70.17,
  y: 37.72,
  width: 1.42,
  height: 37.24,
  transform: "translate(-20.6 5.95) rotate(-19.1)"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 81.53,
  y: 60,
  width: 31.18,
  height: 1.42,
  transform: "translate(-6.05 101.09) rotate(-64.03)"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 102.22,
  y: 78.94,
  width: 1.42,
  height: 38.79,
  transform: "matrix(0.52, -0.86, 0.86, 0.52, -40.45, 115.5)"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 55.43,
  y: 73.05,
  width: 1.42,
  height: 23.33,
  transform: "translate(-38.61 114) rotate(-85.71)"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: 103,
  cy: 15.84,
  r: 15.13
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M106.56,51.82A15.84,15.84,0,1,1,124.7,38.68,15.85,15.85,0,0,1,106.56,51.82Zm4.77-29.88a14.42,14.42,0,1,0,12,16.51A14.44,14.44,0,0,0,111.33,21.94Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 58.7,
  cy: 18.33,
  r: 10.34
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 84.52,
  y: 83.04,
  width: 37.24,
  height: 1.42,
  transform: "translate(-22.21 4.9) rotate(-12.95)"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-2",
  cx: 113.56,
  cy: 60.47,
  r: 8.82
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M118.36,95.9a55.68,55.68,0,0,1,10.07-.9c5.62,0,9.85,1.45,12.45,4a12.4,12.4,0,0,1,3.62,9.23,13.28,13.28,0,0,1-3.27,9.41c-3,3.46-8.07,5.26-13.84,5.26a20,20,0,0,1-5.71-.56v20.14h-3.32Zm3.32,23.5a20.87,20.87,0,0,0,6,.69c8.43,0,13.48-4.09,13.48-11.55s-5.36-10.75-12.84-10.75a34.64,34.64,0,0,0-6.62.56Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M311.85,177.06c.06-.82.1-1.85.1-2.7V159.91h1.14v7.71h.05a4.48,4.48,0,0,1,4.24-2.42c2.94,0,5,2.45,5,5.93,0,4.15-2.62,6.19-5.17,6.19A4.4,4.4,0,0,1,313,175H313l-.08,2.09Zm1.24-4.48a3.48,3.48,0,0,0,.11.85,3.89,3.89,0,0,0,3.81,2.94c2.65,0,4.17-2.18,4.17-5.2,0-2.66-1.45-5-4.07-5a4.23,4.23,0,0,0-4,4.11Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M329.54,165.46l3,7.58c.32.82.64,1.76.85,2.5h.05c.23-.72.54-1.62.88-2.57l2.84-7.51h1.22L335,174.12c-1.41,3.59-2.39,5.74-3.91,7.06a6.29,6.29,0,0,1-2,1.21l-.37-1a6,6,0,0,0,2-1.29,9.2,9.2,0,0,0,1.94-2.92,1.46,1.46,0,0,0,.14-.5,1.45,1.45,0,0,0-.14-.51l-4.3-10.75Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M355.59,160.78h1.15v15.31H364v1h-8.4Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M372.72,162.15a.93.93,0,1,1-1.86,0,1,1,0,0,1,.94-1A1,1,0,0,1,372.72,162.15Zm-1.5,14.91v-11.6h1.15v11.6Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M381.17,177.06V166.39H379.5v-.93h1.67v-.63a5.74,5.74,0,0,1,1.28-4.17,3.83,3.83,0,0,1,4.31-.62l-.37.9a3,3,0,0,0-1.47-.33c-2.15,0-2.6,2-2.6,4.2v.65h3.1v.93h-3.1v10.67Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M392.07,171.15c0,3.7,2,5.17,4.41,5.17a6.71,6.71,0,0,0,3.22-.66l.3.91a7.87,7.87,0,0,1-3.66.74c-3.33,0-5.41-2.43-5.41-5.82,0-3.87,2.22-6.29,5.22-6.29,3.79,0,4.51,3.57,4.51,5.24a4.74,4.74,0,0,1,0,.71Zm7.39-.92c0-1.62-.64-4.08-3.46-4.08-2.55,0-3.66,2.3-3.87,4.08Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M418.34,171.15c0,4.33-3,6.17-5.55,6.17-3,0-5.31-2.33-5.31-6,0-4,2.6-6.15,5.48-6.15C416.16,165.2,418.34,167.6,418.34,171.15Zm-9.7.15c0,2.89,1.85,5.07,4.23,5.07s4.31-2.19,4.31-5.16c0-2.12-1.19-5.06-4.25-5.06S408.64,168.8,408.64,171.3Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M426.12,168.23c0-1.06,0-1.86-.1-2.77h1.07l.08,2.1h.05a4.37,4.37,0,0,1,4-2.36c1.11,0,4.05.56,4.05,4.91v6.95h-1.15v-6.85c0-2.11-.81-4-3.21-4a3.73,3.73,0,0,0-3.48,2.67,4,4,0,0,0-.15,1v7.18h-1.15Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M443.91,160.78h1.15V169h.08c.48-.65,1-1.2,1.39-1.71l5.77-6.54h1.42l-6.2,6.91,6.78,9.37h-1.39l-6.18-8.58-1.67,1.83v6.75h-1.15Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M461.19,171.15c0,3.7,2,5.17,4.41,5.17a6.76,6.76,0,0,0,3.23-.66l.29.91a7.87,7.87,0,0,1-3.66.74c-3.33,0-5.4-2.43-5.4-5.82,0-3.87,2.21-6.29,5.21-6.29,3.8,0,4.52,3.57,4.52,5.24a3.56,3.56,0,0,1,0,.71Zm7.39-.92c0-1.62-.64-4.08-3.46-4.08-2.55,0-3.66,2.3-3.87,4.08Z",
  transform: "translate(-6.06 -20.34)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M477.21,165.46l3,7.58c.32.82.64,1.76.85,2.5h.05c.24-.72.54-1.62.88-2.57l2.84-7.51h1.23l-3.48,8.66c-1.4,3.59-2.39,5.74-3.9,7.06a6.41,6.41,0,0,1-2,1.21l-.37-1a6,6,0,0,0,2-1.29,9,9,0,0,0,1.94-2.92,1.46,1.46,0,0,0,.14-.5,1.25,1.25,0,0,0-.14-.51L476,165.46Z",
  transform: "translate(-6.06 -20.34)"
});

function SvgPatientHubLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer-1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482.9 162.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientHubLogo);
export default __webpack_public_path__ + "static/media/patientHubLogo.e418a90142fc0fdb52c65797697cdd7c.svg";
export { ForwardRef as ReactComponent };